<div class="report-container">

  <div class="page-container pt-1-5">
    <div class="page-header">
      <h1>Sales Report</h1>
      <div class="controls">
        <div class="selection-container">
          <select [(ngModel)]="selectedPeriod" (ngModelChange)="onPeriodChange($event)" class="period-select">
            <option value="">-- Select Period --</option>
            <option *ngFor="let period of periods" [value]="period">{{ period }}</option>
          </select>
        </div>
      </div>
    </div>

    <div *ngIf="!selectedPeriod" class="info-message-card mb-2">
      Please select a period to view the sales reports.
    </div>

    <div class="report-body" *ngIf="selectedPeriod">
      
      <div class="active-scope-bar" data-testid="sr-active-scope">
        <span *ngIf="activeBrandName">Brand: <strong>{{ activeBrandName }}</strong></span>
        <span>Period: <strong>{{ selectedPeriod }}</strong></span>
        <span *ngIf="filterCountry !== 'All'">Country: <strong>{{ filterCountry }}</strong></span>
      </div>

      <!-- Dashboard Stats -->
      <div class="dashboard-container">
        <div class="stat-card">
          <div class="stat-title">Total Revenue (USD)</div>
          <div class="stat-value income">{{ dashboardStats.totalRevenue | currency }}</div>
        </div>
      </div>

      <!-- Toolbar -->
      <div class="toolbar-container right-aligned">
        <div class="country-filter-dropdown">
          <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCountryFilterDropdown()">
            <span>{{ filterCountry === 'All' ? 'All Countries' : filterCountry }}</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCountryFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </button>
          <div class="dropdown-menu" *ngIf="showCountryFilterDropdown">
            <div class="dropdown-item" (click)="selectCountryFilter('All')">
              <span>All Countries</span>
            </div>
            <div class="dropdown-divider" *ngIf="availableCountries.length > 0"></div>
            <div class="dropdown-scroll">
              <div class="dropdown-item" *ngFor="let c of availableCountries" (click)="selectCountryFilter(c)">
                <span>{{ c }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <div class="company-filter-dropdown">
          <button class="action-btn utility-btn dropdown-trigger-btn" (click)="toggleCompanyFilterDropdown()">
            <span>Select Companies ({{ activeFilterCompanyIdsCount }}/{{ activeTabCompanies.length }})</span>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rotated]="showCompanyFilterDropdown"><polyline points="6 9 12 15 18 9"></polyline></svg>
          </button>
          <div class="dropdown-menu" *ngIf="showCompanyFilterDropdown">
            <div class="dropdown-item" (click)="toggleAllCompanyFilter()">
              <input type="checkbox" [checked]="isAllActiveCompaniesSelected" (click)="$event.stopPropagation(); toggleAllCompanyFilter()">
              <span>Select All</span>
            </div>
            <div class="dropdown-item" (click)="toggleKcegOwnedFilter()">
              <input type="checkbox" [checked]="isKcegOwnedSelected" (click)="$event.stopPropagation(); toggleKcegOwnedFilter()">
              <span>Select KCEG Owned</span>
            </div>
            <div class="dropdown-divider"></div>
            <div class="dropdown-scroll">
              <div class="dropdown-item" *ngFor="let company of activeTabCompanies" (click)="toggleCompanyFilterItem(company.id)">
                <input type="checkbox" [checked]="filterCompanyIds.has(company.id)" (click)="$event.stopPropagation(); toggleCompanyFilterItem(company.id)">
                <span>{{ company.company }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Grid Table -->
      <div class="card no-padding overflow-visible">
        <div *ngIf="isLoadingGrid" class="loading-container">
          <div class="spinner spinner-center"></div>
          Loading company data...
        </div>
        
        <div *ngIf="!isLoadingGrid && gridLoadError" class="error-banner" data-testid="sr-error" role="alert">
          Could not load the sales report. Check your connection and try again.
        </div>

        <table class="data-table" *ngIf="!isLoadingGrid && !gridLoadError">
          <thead>
            <tr>
              <th class="text-center">Sent</th>
              <th class="text-center">Company Name</th>
              <th class="text-center">Location (Address)</th>
              <th class="text-center">Total Revenue (USD)</th>
              <th class="text-center">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of filteredCompanyGridData">
              <td class="text-center">
                <span class="status" [class.status-sent]="row.emailStatus === 'Sent'" [class.status-not-sent]="row.emailStatus !== 'Sent'">
                  {{ row.emailStatus || 'Not Sent' }}
                </span>
              </td>
              <td class="fw-500 text-dark">{{ row.companyName }}</td>
              <td>{{ row.address || '-' }}</td>
              <td class="text-right text-success">{{ row.totalRevenue | currency }}</td>
              <td class="text-center">
                <div class="action-buttons-container">
                  <button class="action-btn view-btn" (click)="viewReport(row)">View</button>
                  <button class="action-btn upload-btn" (click)="openImageUploadModal(row)" title="Upload Image">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>
                  </button>
                  <button class="action-btn email-btn" (click)="emailSingleReport(row)" title="Email Report">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline></svg>
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="filteredCompanyGridData.length === 0">
              <td colspan="5" class="empty-table-msg-large" data-testid="sr-empty">{{ activeBrandName ? 'No companies found for ' + activeBrandName + '.' : 'No companies found.' }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Shared Sales Report Modal -->
<app-sales-report-modal
  [isOpen]="isReportModalOpen"
  [company]="selectedCompany"
  [period]="selectedPeriod"
  [totalRevenue]="reportData?.totalRevenue || 0"
  [imageAttachments]="reportData?.imageAttachments || []"
  [imageUrl]="reportData?.imageUrl || null"
  [showPdfActions]="true"
  (close)="closeReportModal()"
></app-sales-report-modal>

<!-- Hidden PDF Template -->
<div id="sales-report-pdf-wrapper">
  <div id="sales-pdf-content" class="pdf-wrapper" *ngIf="reportData">
    <div class="pdf-header-panel">
      <div class="card header-card">
        <div class="company-info">
          <h2>{{ selectedCompany?.company }}</h2>
          <p class="subtle">{{ selectedCompany?.address }}</p>
        </div>
        <div class="date-info">
          <div class="info-item" *ngIf="activeBrandName"><label>Brand:</label><span>{{ activeBrandName }}</span></div>
          <div class="info-item"><label>Statement Period:</label><span>{{ displayPeriod }}</span></div>
        </div>
      </div>

      <div class="summary-grid">
        <div class="card summary-card">
          <label>Total Revenue (USD)</label>
          <span class="value income">{{ reportData?.totalRevenue | currency:'USD':'symbol':'1.2-2' }}</span>
          <div class="report-date-range-sub">
            <span class="range-label">Report Date Range:</span>
            <span class="range-val">{{ monthlyDateRange.display }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Monthly Breakdown Table for PDF -->
    <div class="monthly-table-container">
      <table class="monthly-breakdown-table pdf-table">
        <thead>
          <tr>
            <th class="text-center th-store">StoreID</th>
            <th class="text-center th-device">Device ID</th>
            <th class="text-center th-name">Device Name</th>
            <th class="text-center th-paper">Paper</th>
            <th class="text-center th-paytype">Payment Type</th>
            <th class="text-center th-sales">Sales</th>
            <th class="text-center th-groupsum">Group Sum</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of filteredMonthlyDetailRows">
            <!-- Sub-row 1: Card -->
            <tr class="device-row-top">
              <td rowspan="2" class="text-center fw-600 cell-merged">{{ row.storeId }}</td>
              <td rowspan="2" class="text-center cell-merged">{{ row.deviceId }}</td>
              <td rowspan="2" class="text-center cell-merged">{{ row.deviceName }}</td>
              <td rowspan="2" class="text-center cell-merged">{{ row.paper | number }}</td>
              <td class="text-center font-medium">Card</td>
              <td class="text-right font-num">{{ row.card.sales | currency:'USD':'symbol':'1.2-2' }}</td>
              <td rowspan="2" class="text-center fw-600 cell-merged cell-groupsum">{{ row.groupSum | currency:'USD':'symbol':'1.2-2' }}</td>
            </tr>
            <!-- Sub-row 2: Cash -->
            <tr class="device-row-bottom">
              <td class="text-center font-medium">Cash</td>
              <td class="text-right font-num">{{ row.cash.sales | currency:'USD':'symbol':'1.2-2' }}</td>
            </tr>
          </ng-container>

          <tr *ngIf="filteredMonthlyDetailRows.length === 0">
            <td colspan="7" class="empty-state text-center py-4">No report records found for this period.</td>
          </tr>
        </tbody>
        <tfoot *ngIf="filteredMonthlyDetailRows.length > 0">
          <tr class="total-sum-row">
            <td colspan="3" class="text-center fw-bold">Total Sum</td>
            <td class="text-center"></td>
            <td class="text-center"></td>
            <td class="text-right fw-bold">{{ monthlyTotals.sales | currency:'USD':'symbol':'1.2-2' }}</td>
            <td class="text-center fw-bold">{{ monthlyTotals.groupSum | currency:'USD':'symbol':'1.2-2' }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
    
    <!-- Attached Images Pages -->
    <ng-container *ngIf="reportData?.imageAttachments?.length || reportData?.imageUrl">
      <div class="pdf-page-break"></div>
      <div class="attached-images-section">
        <!-- Legacy Image -->
        <div *ngIf="reportData?.imageUrl && !reportData?.imageAttachments?.length" class="attached-image-page">
          <div class="attached-image-container">
            <img [src]="reportData.imageUrl" crossorigin="anonymous" referrerpolicy="no-referrer" alt="Attached Report Document">
          </div>
        </div>
        <!-- Multiple Images -->
        <div *ngFor="let img of reportData?.imageAttachments" class="attached-image-page">
          <div class="attached-image-container">
            <img [src]="img.url" crossorigin="anonymous" referrerpolicy="no-referrer" [alt]="img.name">
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</div>

<!-- Email Overlay/Form -->
<div class="modal-overlay overlay-z2000" *ngIf="isSavingPDFs">
  <div class="processing-box">
    <div class="spinner spinner-mb"></div>
    <p class="processing-text">Processing PDF attachment...</p>
  </div>
</div>

<app-email-form 
  *ngIf="isEmailModalOpen" 
  [to]="emailData.to" 
  [subject]="emailData.subject" 
  [body]="emailData.body"
  [templateType]="'sales_report'"
  (emailSent)="onEmailSent($event)"
  (close)="closeEmailModal(true)" 
  [attachments]="emailData.attachments"
></app-email-form>

<!-- Image Upload Modal -->
<div class="modal-overlay" *ngIf="isImageUploadModalOpen" (click)="closeImageUploadModal()">
  <div class="modal-content upload-modal-content" (click)="$event.stopPropagation()">
    <div class="modal-sticky-header">
      <h2>Upload Image</h2>
      <div class="header-actions">
        <button class="close-btn-static" (click)="closeImageUploadModal()" [disabled]="uploadingImage">&times;</button>
      </div>
    </div>
    
    <div class="modal-body scrollable-modal-body">
      <p class="upload-modal-text">
        Upload an image for <strong>{{ currentUploadRow?.companyName }}</strong> ({{ displayPeriod }})
      </p>

      <div class="existing-images-container" *ngIf="currentUploadRow?.imageAttachments?.length || currentUploadRow?.imageUrl">
        <h3>Currently Attached</h3>
        <div class="image-list">
          <div class="image-item" *ngIf="currentUploadRow?.imageUrl && !currentUploadRow?.imageAttachments?.length">
            <img [src]="currentUploadRow.imageUrl" alt="Legacy Attachment">
            <span class="image-name">Legacy Image</span>
            <button class="delete-img-btn" (click)="deleteLegacyImage()" title="Delete">&times;</button>
          </div>
          <div class="image-item" *ngFor="let img of currentUploadRow?.imageAttachments; let i = index">
            <img [src]="img.url" [alt]="img.name">
            <span class="image-name" [title]="img.name">{{ img.name }}</span>
            <button class="delete-img-btn" (click)="deleteImage(i)" title="Delete" [disabled]="deletingImageIndex === i || uploadingImage">
              <span *ngIf="deletingImageIndex === i">...</span>
              <span *ngIf="deletingImageIndex !== i">&times;</span>
            </button>
          </div>
        </div>
      </div>
      
      <input type="file" id="imageUploadInput" class="file-input" accept="image/*" (change)="onImageFileSelected($event)" [disabled]="uploadingImage">

      <div *ngIf="uploadingImage" class="uploading-container">
        <div class="uploading-header">
          <span>Uploading...</span>
          <span>{{ imageUploadProgress }}%</span>
        </div>
        <div class="progress-bar-container">
          <div class="progress-bar-fill" [style.width.%]="imageUploadProgress"></div>
        </div>
      </div>

      <div *ngIf="uploadedImageUrl" class="upload-success-msg">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>
        Successfully uploaded!
      </div>

      <div class="upload-modal-actions">
        <button class="action-btn pdf-btn" (click)="closeImageUploadModal()" [disabled]="uploadingImage">Close</button>
        <button class="action-btn view-btn" (click)="uploadImage()" [disabled]="!selectedImageFile || uploadingImage">
          {{ uploadingImage ? 'Uploading...' : 'Upload Image' }}
        </button>
      </div>
    </div>
  </div>
</div>